<!--
  DÉCLENCHEUR. Un bouton, et non plus un champ : le champ de la barre ne cherchait rien, et taper
  dedans laissait croire le contraire. Il garde l'apparence d'un champ — c'est l'endroit où l'on
  s'attend à chercher — mais annonce ce qu'il fait : il ouvre la recherche.
-->
<button type="button" class="declencheur" (click)="ouvrir()" aria-haspopup="dialog" [attr.aria-label]="placeholder()" [attr.aria-keyshortcuts]="estMac ? 'Meta+K /' : 'Control+K /'">
  <svg lucideIcon="search" class="icone-loupe" aria-hidden="true"></svg>
  <span class="indice">{{ placeholder() }}</span>
  <kbd>{{ raccourci }}</kbd>
</button>

<dialog
  #dialog
  class="palette"
  [attr.aria-label]="textes().ouvrir"
  (close)="surFermeture()"
  (cancel)="surAnnulation($event)"
  (click)="surClicDialog($event)"
>
  <div class="panneau">
      <div class="entete">
        <svg lucideIcon="search" class="icone-loupe" aria-hidden="true"></svg>
        <input
          #champ
          type="text"
          class="champ"
          role="combobox"
          aria-autocomplete="list"
          aria-expanded="true"
          aria-controls="rg-liste"
          autocomplete="off"
          spellcheck="false"
          [attr.aria-activedescendant]="idActif()"
          [placeholder]="placeholder()"
          [attr.aria-label]="placeholder()"
          [value]="requete()"
          (input)="surSaisie($any($event.target).value)"
          (keydown)="surToucheChamp($event)"
        />
        <button type="button" class="fermer" (click)="fermer()" [attr.aria-label]="textes().fermer" tabindex="-1">
          <kbd>Esc</kbd>
        </button>
      </div>

      @if (aide()) {
        <!-- Aide des raccourcis (« ? ») : la liste de résultats cède la place, le champ garde le focus. -->
        <div class="liste aide" role="region" [attr.aria-label]="textes().aideTitre">
          <div class="titre-section">{{ textes().aideTitre }}</div>
          <dl class="raccourcis">
            @for (r of raccourcisAide(); track r.touches) {
              <div class="raccourci">
                <dt>
                  @for (t of r.touches.split(' '); track $index) {<kbd>{{ t }}</kbd>}
                </dt>
                <dd>{{ r.effet }}</dd>
              </div>
            }
          </dl>
        </div>
      } @else {
      <div #liste id="rg-liste" class="liste" role="listbox" [attr.aria-label]="textes().ouvrir" [attr.aria-busy]="chargement()">
        @for (section of sections(); track section.id) {
          <div class="section" role="group" [attr.aria-labelledby]="'rg-titre-' + section.id">
            <div class="titre-section" [id]="'rg-titre-' + section.id" role="presentation">{{ section.titre }}</div>
            @for (r of section.resultats; track r.domId; let i = $index) {
              <a
                class="resultat"
                role="option"
                [id]="r.domId"
                [href]="href(r)"
                [class.est-actif]="section.debut + i === actif()"
                [attr.aria-selected]="section.debut + i === actif()"
                tabindex="-1"
                (mousemove)="section.debut + i !== actif() && activer(section.debut + i)"
                (click)="surClicResultat($event, r)"
              >
                <span class="pastille-icone" aria-hidden="true">
                  @if (r.icone) {
                    <svg [lucideIcon]="r.icone" class="icone"></svg>
                  }
                </span>
                <span class="textes">
                  <span class="libelle">
                    @for (s of r.segments; track $index) {
                      @if (s.surligne) {<mark>{{ s.texte }}</mark>} @else {{{ s.texte }}}
                    }
                  </span>
                  @if (r.libelleAlterne) {
                    <span class="alterne" [attr.lang]="lang() === 'ar' ? 'fr' : 'ar'">{{ r.libelleAlterne }}</span>
                  }
                  @if (r.detailSegments) {
                    <span class="alterne detail">
                      @for (s of r.detailSegments; track $index) {
                        @if (s.surligne) {<mark>{{ s.texte }}</mark>} @else {{{ s.texte }}}
                      }
                    </span>
                  }
                </span>
                <kbd class="entree" aria-hidden="true">↵</kbd>
              </a>
            }
          </div>
        } @empty {
          @if (!chargement()) {
            <p class="vide">{{ textes().aucun }}</p>
          }
        }
        @if (chargement()) {
          <p class="chargement" role="status">{{ textes().chargement }}</p>
        }
      </div>
      }

      <!-- Annonce polie du nombre de résultats : sans elle, un lecteur d'écran tape à l'aveugle. -->
      <div class="sr-only" aria-live="polite">{{ requete() ? textes().nombre(resultats().length) : '' }}</div>

      <div class="pied" aria-hidden="true">
        <span><kbd>↑</kbd><kbd>↓</kbd> {{ textes().naviguer }}</span>
        <span><kbd>Tab</kbd> {{ textes().section }}</span>
        <span><kbd>↵</kbd> {{ textes().valider }}</span>
        <span><kbd>{{ estMac ? '⌘' : 'Ctrl' }}</kbd><kbd>↵</kbd> {{ textes().onglet }}</span>
        <span><kbd>Esc</kbd> {{ textes().quitter }}</span>
        <span class="pied-aide"><kbd>?</kbd> {{ textes().aideIndice }}</span>
      </div>
  </div>
</dialog>
